import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedUpdate = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 100 100" width={width} height={height}>
            <path
                className={styles.cls1}
                d="M49.91,98.75A48.68,48.68,0,1,1,98.59,50.07,48.74,48.74,0,0,1,49.91,98.75Zm0-94.31A45.63,45.63,0,1,0,95.54,50.07,45.69,45.69,0,0,0,49.91,4.44Z"
            />
            <path
                className={styles.cls1}
                d="M67.69,69.33a.92.92,0,0,1-.92-.91V45.32h-7a.92.92,0,1,1,0-1.83h7.92a.91.91,0,0,1,.91.91v24A.91.91,0,0,1,67.69,69.33Z"
            />
            <path
                className={styles.cls1}
                d="M67.69,70.09A1.68,1.68,0,0,1,66,68.42V46.08H59.77a1.68,1.68,0,1,1,0-3.35h7.92a1.68,1.68,0,0,1,1.68,1.67v24A1.68,1.68,0,0,1,67.69,70.09ZM59.77,44.25a.16.16,0,0,0-.16.15.16.16,0,0,0,.16.16h7.77V68.42c0,.17.3.17.3,0v-24a.15.15,0,0,0-.15-.15Z"
            />
            <path
                className={styles.cls1}
                d="M36.47,51a.92.92,0,0,1-.91-.92V47a.92.92,0,0,1,.91-.92h5.31a.92.92,0,1,1,0,1.83H37.39v2.16A.92.92,0,0,1,36.47,51Z"
            />
            <path
                className={styles.cls1}
                d="M36.47,51.79a1.68,1.68,0,0,1-1.67-1.68V47a1.68,1.68,0,0,1,1.67-1.68h5.31a1.68,1.68,0,1,1,0,3.35H38.15v1.4A1.68,1.68,0,0,1,36.47,51.79Zm0-4.91a.16.16,0,0,0-.15.16v3.07c0,.17.31.17.31,0V47.19h5.15a.15.15,0,0,0,.15-.15.15.15,0,0,0-.15-.16Z"
            />
            <path
                className={styles.cls1}
                d="M66.54,74.91H35.32a.92.92,0,0,1-.83-.55L25.71,54.55a.92.92,0,0,1,.84-1.29H57.76a.93.93,0,0,1,.84.55l8.78,19.81a.92.92,0,0,1-.84,1.29ZM35.92,73.08H65.13l-8-18H28Z"
            />
            <path
                className={styles.cls1}
                d="M66.54,75.67H35.32a1.67,1.67,0,0,1-1.53-1L25,54.86a1.68,1.68,0,0,1,1.54-2.36H57.76a1.65,1.65,0,0,1,1.53,1l8.78,19.82a1.67,1.67,0,0,1-1.53,2.35ZM26.55,54l-.14.22,8.77,19.82a.17.17,0,0,0,.14.09H66.54a.16.16,0,0,0,.13-.08L57.9,54.12a.15.15,0,0,0-.14-.1ZM66.31,73.84H35.42L26.78,54.33H57.66Zm-29.9-1.52H64L56.67,55.85H29.12Z"
            />
            <path
                className={styles.cls1}
                d="M55.91,49.75H46.28a.91.91,0,0,1-.91-.91v-21H42.42a.91.91,0,0,1-.83-.53.92.92,0,0,1,.14-1L50.4,16.2a.94.94,0,0,1,1.39,0l8.67,10.12a.92.92,0,0,1,.14,1,.91.91,0,0,1-.83.53h-3v21A.91.91,0,0,1,55.91,49.75ZM47.2,47.93H55v-21a.92.92,0,0,1,.92-.92h1.87L51.1,18.2,44.41,26h1.87a.92.92,0,0,1,.92.92Z"
            />
            <path
                className={styles.cls1}
                d="M55.91,50.52H46.29a1.68,1.68,0,0,1-1.68-1.68V28.59H42.42a1.68,1.68,0,0,1-1.52-1,1.7,1.7,0,0,1,.25-1.79L49.82,15.7a1.68,1.68,0,0,1,1.27-.57h0a1.68,1.68,0,0,1,1.27.57L61,25.83a1.67,1.67,0,0,1-1.27,2.76H57.58V48.84A1.68,1.68,0,0,1,55.91,50.52ZM51,16.7,42.31,26.82a.14.14,0,0,0,0,.16.13.13,0,0,0,.13.09h3.71V48.84a.16.16,0,0,0,.16.15h9.62a.15.15,0,0,0,.15-.15V27.07h3.71a.15.15,0,0,0,.14-.09.16.16,0,0,0,0-.16L51.21,16.7Zm4.77,32H46.44V26.92a.16.16,0,0,0-.15-.16H42.76L51.1,17l8.34,9.73H55.91a.16.16,0,0,0-.16.16ZM48,47.16h6.27V26.92a1.68,1.68,0,0,1,1.68-1.68h.21l-5-5.87-5,5.87h.22A1.68,1.68,0,0,1,48,26.92Z"
            />
        </svg>
    );
};

export default GetStartedUpdate;
